import type { Clients } from "@agrigate/rpc-clients";
import { override } from "@agrigate/ts-utils/lib/function";
import type { WrappedFnImpl } from "overridable-fn";
import { fn } from "overridable-fn";

export const getRPC: WrappedFnImpl<[], Clients> = fn.memo<never[], Clients>(
    override("getRPC"),
);
